import React from "react";
import PropTypes from "prop-types";

import * as S from "./AdvantagesSection.style";

const AdvantagesSection = ({ advantagesList }) => {
  return (
    <S.AdvantagesSectionContainer>
      <S.AdvantagesSectionContent className="container">
        {Array.isArray(advantagesList)
          ? advantagesList.map((advantageItem) => (
              <S.AdvantagesSectionItem key={advantageItem?.id}>
                <advantageItem.icon />

                <S.AdvantagesSectionItemContent>
                  <S.AdvantagesSectionItemTitle>
                    {advantageItem?.title}
                  </S.AdvantagesSectionItemTitle>

                  <S.AdvantagesSectionItemDescription>
                    {advantageItem?.description}
                  </S.AdvantagesSectionItemDescription>
                </S.AdvantagesSectionItemContent>
              </S.AdvantagesSectionItem>
            ))
          : []}
      </S.AdvantagesSectionContent>
    </S.AdvantagesSectionContainer>
  );
};
AdvantagesSection.propTypes = {
  advantagesList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      icon: PropTypes.elementType.isRequired,
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
};

AdvantagesSection.defaultProps = {
  advantagesList: [],
};

export default AdvantagesSection;
